import { Button } from 'components/elements'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

const IndustryGenomeContainer = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 500px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  border-radius: 5px;
  margin-bottom: 10px;
`

const IndustryGenomeTitle = styled.p`
  ${({ theme }) => theme.font.body}
`

const GenomeIcon = styled.img`
  aspect-ratio: 383 / 47;
  width: 100%;
  object-fit: contain;
  margin-bottom: 10px;
`

export const IndustryGenomeBanner = () => {
  return (
    <Link href="https://industrygenome.com/discount/TSN-PAO" passHref>
      <IndustryGenomeContainer target="_blank">
        <GenomeIcon src="/assets/industryGENOME.png" alt="Genome" />
        <IndustryGenomeTitle>
          <strong>industyrGENOME</strong>: An AI-based market intelligence tool
          for the health sciences industry
        </IndustryGenomeTitle>

        <Button style={{ height: 'unset' }}>Learn more</Button>
      </IndustryGenomeContainer>
    </Link>
  )
}

export default IndustryGenomeBanner
